var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom d-inline"},[_c('bee-label',{staticClass:"custom d-inline",attrs:{"color":_vm.type && _vm.withColor ? _vm.perspective ?( _vm.type == 'debit' ? 'green' : 'red') : ( _vm.type == 'debit' ? 'red' : 'green') : 'black',"bold":true,"content":_vm.value,"empty-state":_vm.emptyState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }